const footerNav = [
  { id: "hot", label: "热榜速览" },
  { id: "lexicon", label: "名词速览" },
  { id: "reads", label: "深读文章" },
  { id: "facts", label: "冷知识" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];

const catQuick = ["塌房与翻车", "证据与实锤", "粉丝与舆论", "营销与操作", "网络热梗", "典故与来源"];

export default function Footer() {
  const jump = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2.5 cursor-pointer"
            >
              <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-quill-pen-fill text-base leading-none"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">吃瓜百科</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-6 text-background-100/80">
              用通俗语言解释热点事件里的术语、名词与典故来源。看懂热闹，也看懂门道。
            </p>
          </div>

          {/* 栏目 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50">站内栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {footerNav.map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      jump(n.id);
                    }}
                    className="text-sm text-background-100/75 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 分类 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {catQuick.map((c) => (
                <li key={c}>
                  <a
                    href="#lexicon"
                    onClick={(e) => {
                      e.preventDefault();
                      jump("lexicon");
                    }}
                    className="text-sm text-background-100/75 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/75">
              <li>
                <a
                  href="mailto:hello@chigua-baike.cn"
                  className="inline-flex items-center gap-2 transition-colors hover:text-accent-300 cursor-pointer"
                >
                  <i className="ri-mail-line text-base leading-none"></i>
                  hello@chigua-baike.cn
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-seedling-line text-base leading-none"></i>
                内容科普 · 拒绝造谣
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-megaphone-line text-base leading-none"></i>
                让子弹飞一会儿
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-primary-100/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 吃瓜百科 · 本网站内容仅供科普交流，请理性上网、谨慎发声
          </p>
          <p className="flex items-center gap-2 text-xs text-background-100/60">
            <i className="ri-water-flash-line text-accent-300"></i>
            看热闹 · 也看门道
          </p>
        </div>
      </div>
    </footer>
  );
}